import debounce from '../commons/helpers/debounce';

const { $ } = window;

const YurPlanWidgets = {
    EVENT_TYPES: {
        AUTO_HEIGHT: 'autoHeight',
        CHANGE_STEP: 'changeStep',
        SCROLL_IFRAME: 'scrollIframe',
        ONLOAD: 'onload',
        TRACKING: 'tracking',
    },
    STEPS: {
        TICKETS: 'tickets',
        FORM: 'form',
        PRODUCTS: 'products',
        CONFIRMATION: 'confirmation',
        SUMMARY: 'summary',
    },
};

const PARENT_DOMAIN_SESSION_STORAGE_KEY = 'yp_parentDomain';

function sendTrackingData() {
    const trackingData = window.TRACKING_DATA;
    if (!trackingData) {
        return;
    }
    window.TRACKING_DATA.forEach((currentTrackingData) => {
        window.parent.postMessage({
            type: YurPlanWidgets.EVENT_TYPES.TRACKING,
            data: currentTrackingData,
            location: window.location.origin + window.location.pathname,
            title: document.title,
        }, '*');
    });
}

function widgetSendInfoToPage(type) {
    const el = $('#yurplan-widget-body');
    const height = el.outerHeight(true);
    const { widgetConfiguration } = window;

    widgetConfiguration.height = height;
    widgetConfiguration.step = el.data('step');

    try {
        window.parent.postMessage({
            id: el.data('id'),
            data: widgetConfiguration,
            type,
        }, '*');
    } catch (e) {
        /* eslint-disable-next-line no-console */
        console.log('Failed postMessage to window.parent', e);
    }
}

$(() => {
    window.scrollTo(0, 0);

    // Stocker le parentDomain dans sessionStorage pour Apple Pay
    const urlParams = new URLSearchParams(window.location.search);
    const parentDomain = urlParams.get('parentDomain');
    if (parentDomain) {
        sessionStorage.setItem(PARENT_DOMAIN_SESSION_STORAGE_KEY, parentDomain);
        console.log('[WIDGET] Stored parentDomain in sessionStorage:', parentDomain);
    }

    const widgetBody = document.getElementById('yurplan-widget-body');
    const widgetContainer = $(widgetBody).find('.widget');
    const displayLoader = () => widgetContainer.css('opacity', 0.6);

    if (widgetBody) {
        // Options for the observer (which mutations to observe)
        const config = {
            attributes: true,
            childList: true,
            subtree: true,
        };
        const triggerAutoHeightCallback = debounce(
            widgetSendInfoToPage.bind(
                null,
                YurPlanWidgets.EVENT_TYPES.AUTO_HEIGHT,
            ),
            300,
        );
        // Create an observer instance linked to the callback function
        const domSubtreeObserver = new MutationObserver((mutationsList) => {
            const skipEvent = mutationsList.every((mutation) => mutation.target.className.indexOf('ticketing_timer_update') > -1);
            if (skipEvent) return;
            triggerAutoHeightCallback();
        });

        // Start observing the target node for configured mutations
        domSubtreeObserver.observe(widgetBody, config);
        // Also watch resize event
        $(window).on('resize load', triggerAutoHeightCallback);
        // Trigger manually a first auto height to prevent the missed first mutations
        triggerAutoHeightCallback();
    }

    // Fullscreen only happens on Yurplan's own site (parentDomain matches iframe host)
    // and on non-tickets steps. Third-party sites never use fullscreen.
    const isEmbeddedOnOwnSite = YP_CONFIG.events.url.includes(sessionStorage.getItem(PARENT_DOMAIN_SESSION_STORAGE_KEY));

    const isFullscreen = isEmbeddedOnOwnSite
        && $(widgetBody).data('step') !== YurPlanWidgets.STEPS.TICKETS;

    // Only apply overflow restrictions when inside an iframe.
    // When accessed directly (e.g. from activation code page), the page must remain scrollable.
    const isInsideIframe = window.parent !== window;

    if (isFullscreen) {
        document.documentElement.style.overscrollBehavior = 'contain';
        document.body.style.overscrollBehavior = 'contain';
    } else if (isInsideIframe) {
        // Use 'auto' instead of 'hidden' so a scrollbar appears as fallback
        // if the auto-height mechanism fails (e.g. iframe without height="100%").
        document.documentElement.style.overflow = 'auto';
    } else {
        // Full-page widget (direct access, no iframe) — ensure scrolling works
        document.documentElement.style.overflow = 'auto';
        document.body.style.overflow = 'auto';
    }

    // Disable autoscroll for first step (tickets selection)
    if ($(widgetBody).data('step') !== YurPlanWidgets.STEPS.TICKETS) {
        widgetSendInfoToPage(YurPlanWidgets.EVENT_TYPES.SCROLL_IFRAME);
    }

    widgetSendInfoToPage(YurPlanWidgets.EVENT_TYPES.CHANGE_STEP);
    widgetSendInfoToPage(YurPlanWidgets.EVENT_TYPES.AUTO_HEIGHT);

    $(widgetContainer).on('click', 'a.toDisabled', displayLoader);

    $(widgetContainer).on('submit', 'form:not(.ajax)', function displayLoaderOnFormSubmit(e) {
        e.preventDefault();
        const submit = $(this).find('input[type=submit], button[type=submit]');
        submit.attr('disabled', true);
        submit.val(`${submit.val()} ...`);
        displayLoader();
        this.submit();
    });

    // Display signin form
    $(widgetContainer).on('click', '.widget-connect-me', (e) => {
        e.preventDefault();
        $('.widget-register').hide();
        $('.widget-login').show();
        $('.no-account').hide();
    });

    // Display signup form
    $(widgetContainer).on('click', '.back-to-register', (e) => {
        e.preventDefault();
        $('.widget-register').show();
        $('.widget-login').hide();
        $('.no-account').show();
    });

    sendTrackingData();
});

window.addEventListener('message', (message) => {
    switch (message.data.action) {
        case 'passActivationCode':
            document.querySelector('input#accessStoreCodeForm_token').value = message.data.data;
            document.querySelector('form#accessStoreCodeForm').submit();
            break;
        case 'passGenericCode':
            const searchParams = new URLSearchParams(document.location.search);
            searchParams.set('code', message.data.data);
            document.location.search = searchParams.toString();
            break;
        default:
            // Unhandled message
            break;
    }
});

window.addEventListener('load', () => {
    widgetSendInfoToPage(YurPlanWidgets.EVENT_TYPES.ONLOAD);
});

window.YurPlanWidgets = YurPlanWidgets;
